import { createAsyncThunk } from '@reduxjs/toolkit';
import CommonApi from '@infrastructure/common-api';
import { addSuccessNotification } from '../common/notificationSlice';
import { getErrorPayload } from '@application/common/helpers/api-helper';
export const sendEmailWithAttachmentAsync = createAsyncThunk('common/SendEmailWithAttachment', async (email, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CommonApi.sendEmailWithAttachment(email);
        if (response === true)
            dispatch(addSuccessNotification('Email succesvol verzonden'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEmailTemplateByNameAsync = createAsyncThunk('common/getEmailTemplateByName', async (name, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CommonApi.getEmailTemplateByName(name);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
